import { render, staticRenderFns } from "./OverlayEmbed.vue?vue&type=template&id=a8ced30c&"
import script from "./OverlayEmbed.vue?vue&type=script&lang=js&"
export * from "./OverlayEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports